import { useCallback } from 'react';
import { GraphQLError } from 'graphql';

import { useLogger } from '@/shared/hooks/useLogger';
import {
    AppErrors,
    StreamsWatchingRejectionReason,
} from '@/scenarios/legacy-player/components/error-boundary-context/error-map/map';

import { useHandleError } from '../../error-boundary-context/context';

const ERROR_CLASSES = ['WatchingRejectionError', 'DeviceNotFoundError', 'AgeRestrictionError'];

export const useOnGraphQLError = () => {
    const handleError = useHandleError();
    const logger = useLogger();

    const onGraphQLError = useCallback(
        (graphQLError: GraphQLError) => {
            const classification = graphQLError.extensions?.classification;

            if (typeof classification !== 'string' || !ERROR_CLASSES.includes(classification)) {
                return;
            }

            // ToDo fix casting https://st.yandex-team.ru/OTT-62819
            if (graphQLError.extensions?.reason) {
                handleError(graphQLError.extensions?.reason as AppErrors);
                return;
            }

            if (graphQLError.extensions?.type) {
                handleError(graphQLError.extensions?.type as AppErrors);
            }
        },
        [handleError]
    );

    const onError = useCallback(
        (error: Error) => {
            handleError(StreamsWatchingRejectionReason.NETWORK_ERROR, {});
            logger.error({
                message: 'Network error getting streams',
                error,
            });
        },
        [handleError, logger]
    );

    return { onError, onGraphQLError };
};
